import type { Schema } from '../../amplify/data/resource'
import { generateClient } from 'aws-amplify/data'

interface Analise {
    id: string,
    nome: string
}

const client = generateClient<Schema>()

const transformAnaliseData = (data: any): Analise => {
    return {
        id: data?.id ?? '',
        nome: data?.nome ?? ''
    }
}

const getAnalises = async (): Promise<any[]> => {
    try {
        const { data, errors } = await client.models.tbLabquimicoAnalises.list();

        if (errors) {
            throw new Error(`Failed to get Analises: ${errors.map(e => e.message).join(', ')}`)
        }

        return data;
    } catch (error) {
        console.error('Erro ao buscar Analises: ', error);
        throw new Error('Failed to get Analises')
    }
}


const createAnalise = async (analise: any) => {
    await client.models.tbLabquimicoAnalises.create(analise)
}


const updateAnalise = async (analise: Analise): Promise<Analise> => {
    try {
        const analiseAtualizado = {
            ...analise
        }

        const { data, errors } = await client.models.tbLabquimicoAnalises.update(analiseAtualizado)

        if (errors) {
            throw new Error(`Failed to update Analise: ${errors.map(e => e.message)}`)
        }

        const updatedAnalise = transformAnaliseData(data)

        return updatedAnalise
    } catch (error) {
        console.error('Erro ao atualizar analise: ', error)
        throw new Error('Failed to update analise')
    }
}


const deleteAnalise = async (id: string): Promise<void> => {
    try {
      const { errors } = await client.models.tbLabquimicoAnalises.delete({ id });
  
      if (errors) {
        throw new Error(`Failed to delete Analise: ${errors.map(e => e.message).join(', ')}`);
      }
  
      //console.log(`Analise com ID: ${id} foi deletado com sucesso.`);
    } catch (error) {
      console.error('Erro ao deletar analise:', error);
      throw new Error('Failed to delete analise');
    }
  };


export { getAnalises, createAnalise, updateAnalise, deleteAnalise }
export type { Analise }